<template>
	<div class="clickaway">
		<div class="tool-bar">
			<select-btn
				v-model="sortModeIndex"
				:title="sortModeText"
				:multiple="false"
				:icon="sortModeIcon"
				isTitleLeft
				isSelectLeft
				@change="saveAutoReportSortMode"
			>
				<select-option v-for="(item, index) of sortModeList" :value="index" :key="index">
					{{ item.type }}{{ item.isPositive ? '升序' : '降序' }}
				</select-option>
			</select-btn>
			<div style="flex:1;"></div>
			<func-btn class="right-btn" title="重命名" icon="adv-rename"></func-btn>
			<func-btn class="right-btn" title="删除" icon="adv-eraser"></func-btn>
			<select-btn class="right-btn" title="新建" icon="adv-add-circle">
				<select-option>文件夹</select-option>
				<select-option>日报模板</select-option>
				<select-option>上传文档</select-option>
			</select-btn>
		</div>
	</div>
</template>

<script>
import funcBtn from '../../components/display/func-btn'
import selectBtn from '../../components/display/select-btn'
import selectOption from '../../components/display/select-option'
export default {
	name: 'clickaway',
	components: {
		funcBtn,
		selectBtn,
		selectOption
	},
	props: {},
	data() {
		return {
			sortModeIndex: 0,
			sortModeList: [
				{
					type: '文件名',
					value: 'fileName',
					isPositive: true,
					sort: function(a, b) {
						return a.fileName.localeCompare(b.fileName)
					}
				},
				{
					type: '文件名',
					value: 'fileName',
					isPositive: false,
					sort: function(a, b) {
						return b.fileName.localeCompare(a.fileName)
					}
				},
				{
					type: '时间',
					value: 'lastModified',
					isPositive: true,
					sort: function(a, b) {
						return a.lastModified - b.lastModified
					}
				},
				{
					type: '时间',
					value: 'lastModified',
					isPositive: false,
					sort: function(a, b) {
						return b.lastModified - a.lastModified
					}
				}
			]
		}
	},
	computed: {
		sortModeText() {
			return this.sortModeList[this.sortModeIndex].type
		},
		sortModeIcon() {
			return this.sortModeList[this.sortModeIndex].isPositive ? 'adv-arrow-trail-up' : 'adv-arrow-trail-down'
		}
	},
	watch: {},
	methods: {
		saveAutoReportSortMode() {
			localStorage.setItem('autoReportSortMode', this.sortModeIndex)
		}
	},
	created() {
		let autoReportSortMode = localStorage.getItem('autoReportSortMode')
		this.sortModeIndex = autoReportSortMode ? Number(autoReportSortMode) : 0
	},
	mounted() {}
}
</script>

<style lang="less" scoped>
@import './index.less';
.tool-bar {
	background: #f9f9fa;
	display: flex;
	align-items: center;
	.right-btn {
		margin-left: 20px;
	}
}
</style>
